import * as _ from 'lodash-es'
import { DateWithPrecision, parsePrecision } from './date-with-precision'

export function normalizeDates(dateStrings: string[], precisions?: string[]): Date[] {
  if (precisions && precisions.length !== dateStrings.length) {
    throw new Error('Precisions must be the same length as dateStrings')
  }

  const dates = _.uniq(dateStrings)
    .map((date, index) => {
      if (date.startsWith('9999-')) return undefined
      if (!precisions) return new Date(date.replace(/Z$/, ''))

      const dateWithPrecision = new DateWithPrecision(date.replace(/Z$/, ''))
      dateWithPrecision.setPrecision(parsePrecision(precisions[index]))
      return dateWithPrecision
    })
    .filter((date: unknown): date is Date => date instanceof Date && !isNaN(date.getTime()))

  return dates
}

export function isDisplayableImage(url: string): boolean {
  return /\.(png|jpe?g|gif|webp|avif|svg)/i.test(url)
}
